import React, {Component} from 'react';
import '../css/Page.css';

class PageAvvalimenti extends Component {

    render() {
        return (
                <div className="page">
                    <article>

                        <p>L&rsquo;avvalimento &egrave; lo strumento previsto dall&rsquo;art. 89 del D.Lgs 50/2016
                            che consente all&rsquo;Impresa Ausiliata, non in possesso dei requisiti richiesti nei bandi di Gara,
                            di poter ugualmente partecipare utilizzando i requisiti posseduti e messi a disposizione da parte dell&rsquo;Impresa Ausiliaria,
                            con il vantaggio che il lavoro eseguito ed il relativo certificato risulteranno essere in capo sempre all&rsquo;Ausiliata, ossia l&rsquo;impresa
                            che fruisce dell&rsquo;avvalimento in modo da costruire i vostri requisiti per ottenere le vostre future attestazioni.
                            <br/>Grazie alla collaborazione con primarie Imprese e Consorzi nell'ambito dei lavori pubblici, l&rsquo;Areamultiservice &egrave;
                            in grado di fornirvi tutte le categorie e classifiche SOA (secondo il D.Lgs 50/2016) necessarie per la partecipazione a gare
                            che richiedono qualificazioni superiori o diverse a quelle in vostro possesso.
                        </p>
                        <p>Il servizio si compone delle seguenti attivit&agrave;:</p>
                        <ul>
                            <li>Ricerca dell&rsquo;impresa ausiliaria;</li>
                            <li>Redazione del contratto di avvalimento;</li>
                            <li>Produzione delle dichiarazioni sostitutive;</li>
                            <li>Recapito dei documenti.</li>
                        </ul>

                        <h3>Si offrono anche soluzioni di Pacchetti di Avvalimenti con una sensibile riduzione dei costi del singolo Avvalimento.</h3>

                        <p>L&rsquo;Areamultiservice consente a tutte le imprese interessate, di poter aderire al gruppo delle Ausiliarie.
                            <br/>L'adesione &egrave; gratuita, e senza alcun impegno, consentir&agrave; alle imprese di cogliere tantissime opportunit&agrave;. Contattaci se interessati.</p>

                        <p>Per richiedere il servizio vi preghiamo di inviare i seguenti documenti tramite mail:</p>
                        <ul>
                            <li>Copia della CCIAA;</li>
                            <li>Copia del documento d&rsquo;identit&agrave; del L.R.;</li>
                            <li>Copia del certificato SOA (se ne &egrave; in possesso);</li>
                            <li>Recapiti telefonici, fax email e PEC;</li>
                            <li>Bando e disciplinare di gara di avvalimento indicando la categoria e relativa classifica di proprio interesse.</li>
                        </ul>
                        <p>Mail:&nbsp;<a href="mailto:info@areamultiservice.it">info@areamultiservice.it</a> e/o <a href="mailto:serviziappalti@libero.it">serviziappalti@libero.it</a></p>
                        <p>Per ulteriori informazioni contattare il responsabile Ufficio Gare al numero <strong>329/8177540</strong>.</p>

                    </article>
                </div>
        );
    }
}

export default PageAvvalimenti;


// WEBPACK FOOTER //
// ./src/page/js/PageAvvalimenti.js